import React from 'react'
import JobAppBar from './JobAppBar'
import Footer from './Footer'
import { Grid, StylesProvider, Typography, makeStyles } from '@material-ui/core';
import global_isSignedIn from '../views/discovery/global_isSignedIn';


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        minHeight: 'calc(100vh - 0px)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        // paddingTop: 84,
        paddingTop: 74,
        backgroundAttachment: 'fixed',
    },
    pageTitle: {
        color: '#5BC2A8',
        textAlign: 'center',
        marginBottom: '0.2em',
        fontWeight: 500,
    },
    pageBar: {
        //width: 860,
        width: 772,
        flexBasis: 65,
        //marginTop: 35,
        marginTop: 0,
        zIndex: 8,
    },
    pageInfo: {
        display: 'flex',
        justifyContent: 'flex-start',
        paddingTop: 'calc(80vh - 500px);',
        alignItems: 'center',
        flexDirection: 'column',
        height: '80vh',
    },
    pageInfoText: {
        marginBottom: 20,
        color: "#555",
        lineHeight: '2em'
    },
    relevanceMsgBar: {
        width: 860,
        //flexBasis: 65,
        //marginTop: 25,
        zIndex: 8,
        padding: '0',
        marginLeft: 7,
        marginTop: 10,
        background: 'linear-gradient(89deg, rgb(255 255 255 / 0%) 0%, rgb(230 230 230 / 80%) 50%, rgba(255,255,255,0.1) 100%)',
    },
    subtitle: {
        lineHeight: '2em',
        color: '#797979',
        marginRight: 10,
        fontSize: 14,
        fontWeight: 500,
    },
    listViewWrapper: {
        opacity: 1,
        '&.animate': {
            opacity: 0,
            transition: 'opacity 0.25s ease-in-out',
        }
    },
    headerButton: {
        textTransform: "none",
        width: 100,
        height: 35,
    },
    headerButton_pri: {
        backgroundColor: "#14967B",
        color: "white",
        borderRadius: 5,
        '&:hover': {
            backgroundColor: "#14967B",
        },
    },
    headerButton_sec: {
        backgroundColor: "transparent",
        color: "#14967B",
        //border: "1px solid #14967B",
        '&:hover': {
            backgroundColor: "transparent",
        },
    },
    my1: {
        margin: '1em 0'
    },
    mx1: {
        margin: '0 1em'
    },
    mx2: {
        margin: '0 2em'
    },
    fontSmall: {
        fontSize: '0.85rem'
    }
}));

export const PrivacyPolicy = () => {
    const classes = useStyles();
    let sessionCookie = process.env.REACT_APP_NODE_ENV === 'development' ? true : document.cookie.indexOf('connect.sid') === -1 ? null : true;
    const [isSignedIn, setIsSignedIn] = React.useState(sessionCookie && localStorage.getItem("is_logged_in") || false);

    global_isSignedIn.isSignedIn = (sessionCookie && localStorage.getItem("is_logged_in")) || false;

    const checkSignedInStatus = () => {
        return isSignedIn
    }
    const handleSignedInStatus = (v) => {
        setIsSignedIn(v);
    }

    document.body.classList.remove("login");
    document.body.classList.add('wallpaper--icon');

    const [refresh, doRefresh] = React.useState(false);
    const [forRefreshOnly, setForRefreshOnly] = React.useState(false);
    const [canDrawerOpen, setCanDrawerOpen] = React.useState(false);
    const handleDrawer = () => {
        //   AnalyticsHandler.track('SignIn_ViewBtn_CompanyPage');
        setCanDrawerOpen(true)
        doRefresh(prev => !prev)
    }

    return (
        <>
            <StylesProvider injectFirst>
                <div className={classes.root}>
                    <JobAppBar
                        isSignedIn={isSignedIn}
                        setIsSignedIn={handleSignedInStatus}
                        handleDrawer={handleDrawer}
                    />
                    <Typography variant='h5' component='h1'>Privacy Policy</Typography>
                    <div style={{marginBottom: '2em'}} className={classes.mx2}>
                        <Typography className={classes.my1} component='p' variant='h6'>1. Information we collect</Typography>
                        <Typography className={classes.fontSmall} variant='body1' component='p'>
                            Log Data When You Visit Our Website, Our Servers May Automatically Log the Standard Data Provided By Your Web Browser. It May Include Your Computer’s Internet Protocol (IP) Address, Your Browser Type And Version, The Pages You Visit, The Time And Date Of Your Visit, The Time Spent On Each Page, And Other Details. Personal Information We May Ask For Personal Information, Such As Your: Email Phone Number Website Address Payment Information.
                            <br />
                            Business Data Business Data Refers To Data That Accumulates Over The Normal Course Of Operation On Our Platform. This May Include Transaction Records, Stored Files, User Profiles, Analytics Data And Other Metrics, As Well As Other Types Of Information, Created Or Generated, As Users Interact With Our Services.
                        </Typography>
                        {/* </Grid> */}
                        {/* <Grid style={{ margin: '1em 3em' }} item> */}
                        <Typography className={classes.my1} variant='h6'>2. Legal bases for processing</Typography>
                        <Typography className={classes.fontSmall} variant='body1' component='p'>
                            We Will Process Your Personal Information Lawfully, Fairly And In A Transparent Manner. We Collect And Process Information About You Only Where We Have Legal Bases For Doing So. These Legal Bases Depend On The Services You Use And How You Use Them, Meaning We Collect And Use Your Information Only Where: It’s Necessary For The Performance Of A Contract To Which You Are A Party Or To Take Steps At Your Request Before Entering Into Such A Contract (For Example, When We Provide A Service You Request From Us); It Satisfies A Legitimate Interest (Which Is Not Overridden By Your Data Protection Interests), Such As For Research And Development, To Market And Promote Our Services, And To Protect Our Legal Rights And Interests; You Give Us Consent To Do So For A Specific Purpose (For Example, You Might Consent To Us Sending You Our Newsletter); Or We Need To Process Your Data To Comply With A Legal Obligation. Where You Consent To Our Use Of Information About You For A Specific Purpose, You Have The Right To Change Your Mind At Any Time (But This Will Not Affect Any Processing That Has Already Taken Place). We Don’t Keep Personal Information For Longer Than Is Necessary. While We Retain This Information, We Will Protect It Within Commercially Acceptable Means To Prevent Loss And Theft, As Well As Unauthorised Access, Disclosure, Copying, Use Or Modification. That Said, We Advise That No Method Of Electronic Transmission Or Storage Is 100% Secure And Cannot Guarantee Absolute Data Security. If Necessary, We May Retain Your Personal Information For Our Compliance With A Legal Obligation Or In Order To Protect Your Vital Interests Or The Vital Interests Of Another Natural Person.
                        </Typography>
                        <Typography className={classes.my1} variant='h6'>Third Party Services</Typography>
                        <Typography className={classes.fontSmall} variant='body1' component='p'>
                            Third Parties Provide Certain Services Available On www.meetworks.in on Medha Skilling Services Private Limited’s Behalf. ‘Medha Skilling Services Private Limited’ May Provide Information, Including Personal Information, That ‘Medha Skilling Services Private Limited’ Collects On The Web To Third-Party Service Providers To Help Us Deliver Programs, Products, Information, And Services. Service Providers Are Also An Important Means By Which ‘Medha Skilling Services Private Limited’ Maintains Its Web Sites And Mailing Lists. ‘Medha Skilling Services Private Limited’ Will Take Reasonable Steps To Ensure That These Third-Party Service Providers Are Obligated To Protect Personal Information On

                            Medha Skilling Services Private Limited's Behalf. ‘Medha Skilling Services Private Limited’ Does Not Intend To Transfer Personal Information Without Your Consent To Third Parties Who Are Not Bound To Act On Medha Skilling Services Private Limited's Behalf Unless Such Transfer Is Legally Required. Similarly, It Is Against Medha Skilling Services Private Limited's Policy To Sell Personal Information Collected Online Without Consent.
                        </Typography>
                        <Typography className={classes.my1} variant='h6'>Your Consent</Typography>
                        <Typography className={classes.fontSmall} variant='body1' component='p'>
                            By Using This Web Site, You Consent To The Terms Of Our Online Privacy Policy And To Medha Skilling Services Private Limited's Processing Of Personal Information For The Purposes Given Above As Well As Those Explained Where ‘Medha Skilling Services Private Limited’ Collects Personal Information On The Web.
                        </Typography>
                        <Typography className={classes.my1} variant='h6'>Information security</Typography>
                        <Typography className={classes.fontSmall} variant='body1' component='p'>
                            We Take Appropriate Security Measures To Protect Against Unauthorized Access To Or Unauthorized Alteration, Disclosure Or Destruction Of Data. We Restrict Access To Your Personally Identifying Information To Employees Who Need To Know That Information In Order To Operate, Develop Or Improve Our Services.
                        </Typography>
                        <Typography className={classes.my1} variant='h6'>Updating your information</Typography>
                        <Typography className={classes.fontSmall} variant='body1' component='p'>
                            We Provide Mechanisms For Updating And Correcting Your Personally Identifying Information For Many Of Our Services.
                        </Typography>
                        <Typography className={classes.my1} variant='h6'>3. Collection and use of information</Typography>
                        <Typography className={classes.fontSmall} variant='body1' component='p'>
                            We May Collect, Hold, Use And Disclose Information For The Following Purposes And Personal Information Will Not Be Further Processed In A Manner That Is Incompatible With These Purposes: To Provide You With Our Platform's Core Features; To Process Any Transactional Or Ongoing Payments; To Enable You To Access And Use Our Website, Associated Applications And Associated Social Media Platforms; To Contact And Communicate With You; For Internal Record Keeping And Administrative Purposes; And To Comply With Our Legal Obligations And Resolve Any Disputes That We May Have.
                        </Typography>
                        <Typography className={classes.my1} variant='h6'>4. Disclosure of personal information to third parties</Typography>
                        <Typography className={classes.fontSmall} variant='body1' component='p'>
                            We May Disclose Personal Information To: Third Party Service Providers For The Purpose Of Enabling Them To Provide Their Services, Including (Without Limitation) IT Service Providers, Data Storage, Web-Hosting And Server Providers, Debt Collectors, Maintenance Or Problem-Solving Providers, Marketing Or Advertising Providers, Professional Advisors And Payment Systems Operators.
                        </Typography>
                        <Typography className={classes.my1} variant='h6'>5. Your rights and controlling your personal information</Typography>
                        <Typography className={classes.fontSmall} variant='body1' component='p'>
                            Choice And Consent: By Providing Personal Information To Us, You Consent To Us Collecting, Holding, Using And Disclosing Your Personal Information In Accordance With This Privacy Policy. If You Are Under 18 Years Of Age, You Must Have, And Warrant To The Extent Permitted By Law To Us, That You Have Your Parent Or Legal Guardian’s Permission To Access And Use The Website And They (Your Parents Or Guardian) Have Consented To You Providing Us With Your Personal Information. You Do Not Have To Provide Personal Information To Us, However, If You Do Not, It May Affect Your Use Of This Website Or The Products And/Or Services Offered On Or Through It. Information From Third Parties: If We Receive Personal Information About You From A Third Party, We Will Protect It As Set Out In This Privacy Policy. If You Are A Third Party Providing Personal Information About Somebody

                            Else, You Represent And Warrant That You Have Such Person’s Consent To Provide The Personal Information To Us. Restrict: You May Choose To Restrict The Collection Or Use Of Your Personal Information. If You Have Previously Agreed To Us Using Your Personal Information For Direct Marketing Purposes, You May Change Your Mind At Any Time By Contacting Us Using The Details Below. If You Ask Us To Restrict Or Limit How We Process Your Personal Information, We Will Let You Know How The Restriction Affects Your Use Of Our Website Or Products And Services. Access And Data Portability: You May Request Details Of The Personal Information That We Hold About You. You May Request A Copy Of The Personal Information We Hold About You. Where Possible, We Will Provide This Information In CSV Format Or Other Easily Readable Machine Format. You May Request That We Erase The Personal Information We Hold About You At Any Time. You May Also Request That We Transfer This Personal Information To Another Third Party. Correction: If You Believe That Any Information We Hold About You Is Inaccurate, Out Of Date, Incomplete, Irrelevant Or Misleading, Please Contact Us Using The Details Below. We Will Take Reasonable Steps To Correct Any Information Found To Be Inaccurate, Incomplete, Misleading Or Out Of Date. Notification Of Data Breaches: We Will Comply Laws Applicable To Us In Respect Of Any Data Breach. Complaints: If You Believe That We Have Breached A Relevant Data Protection Law And Wish To Make A Complaint, Please Contact Us Using The Details Below And Provide Us With Full Details Of The Alleged Breach. We Will Promptly Investigate Your Complaint And Respond To You, In Writing, Setting Out The Outcome Of Our Investigation And The Steps We Will Take To Deal With Your Complaint. You Also Have The Right To Contact A Regulatory Body Or Data Protection Authority In Relation To Your Complaint. Unsubscribe: To Unsubscribe From Our E-Mail Database Or Opt-Out Of Communications (Including Marketing Communications), Please Contact Us Using The Details on www.meetworks.in Or Opt-Out Using The Opt-Out Facilities Provided In The Communication.
                        </Typography>
                    </div>
                </div>
                <Footer />
            </StylesProvider>
        </>
    )
}
